import {
  get,
  includes,
  find,
  map,
  isFunction,
  merge,
  isEmpty,
  pick,
  startsWith,
  chain,
  set,
  has,
  size,
  isNil,
  isNull,
} from "lodash"
import BigNumber from "bignumber.js"
import qs from "qs"

import { SECURITY_TYPE, RateList, EXCHANGE } from "config/const"
import * as Formatter from "./Formatter"
import { APIResponse } from "redux/apis/types"
import { chartColorSetting } from "redux/ducks/Chart"
import chartColors from "components/atoms/chart/logic/chartColor"
import { defaultTargetExchange } from "components/actions/getProfitAnnouncementCalender"
import { easyEncrypt } from "utils/encrypt"
import { UserStorage } from "utils/userStorage"
import { TERM, PLOTTYPE } from "components/atoms/chart/logic/chartConfig"
import { ROUTE_LIST, countryList } from "config/const"

export const createRequestBit = (arr: Array<number>, total: number) => {
  let res = ""
  for (let i = 0; i < total; i++) {
    if (includes(arr, i)) {
      res = res + "1"
    } else {
      res = res + "0"
    }
  }
  return res
}

//window_open
type windowOptionType = {
  width?: string
  height?: string
  scrollbars?: string
  location?: string
  resizable?: string
}
const WINDOW_OPTIONS: windowOptionType = {
  width: "1024",
  height: "945",
  scrollbars: "yes",
  location: "yes",
  resizable: "yes",
}

let paramNo: number = 0
type WindowOpenType = (
  url: string,
  param?: { [t: string]: string | number },
  target?: string,
  option?: windowOptionType,
  encryptFlag?: boolean
) => Window | null
export const window_open: WindowOpenType = (
  url,
  param,
  target,
  option = {},
  encryptFlag = true
) => {
  if (!isEmpty(param)) {
    param.paramNo = paramNo
    paramNo++
  }

  const window_option = merge({}, WINDOW_OPTIONS, option)
  const _query = encryptFlag
    ? (() => {
        const _string = url_param_str(param)
        return `?${easyEncrypt(_string.slice(1))}`
      })()
    : url_param_str(param)

  return window.open(
    url + _query,
    target,
    Object.keys(window_option)
      .map(key => key + "=" + get(window_option, key))
      .join(",")
  )
}

export const url_param_str = (params: object) => {
  return params ? qs.stringify(params, { addQueryPrefix: true }) : ""
}

let chart_window: Window
const DEFAULT_TERM = TERM[8].id // 日足
const DEFAULT_PLOT_TYPE = PLOTTYPE[0].id // ローソク
export const open_chart = (symbol: APIResponse.Res, options: object) => {
  const params = {
    ...symbol,
    plotType: get(options, "plotType.id", DEFAULT_PLOT_TYPE),
    term: get(options, "term.id", DEFAULT_TERM),
  }

  const size = {
    width: "1200",
    height: "810",
  }
  chart_window = window_open("./#/chart", params, "Tech-Chart", size)
  chart_window.focus()
}

let symbol_detail_window: Window
export const open_symbol_detail = (
  symbol?: APIResponse.Res,
  options?: object
) => {
  const param = size(symbol)
    ? {
        Symbol: get(symbol, "Symbol"),
        SecurityType: get(symbol, "SecurityType"),
        Exchange: get(symbol, "Exchange"),
      }
    : {}
  const tab = get(options, "tab", {})
  symbol_detail_window = window_open(
    "./#/SymbolDetail",
    { ...param, tab },
    "Symbol_Detail"
  )
  symbol_detail_window.focus()
}

//表示系
export const formatDisplayPrice: (data: APIResponse.Res) => string = data => {
  const seqType = get(data, "SecurityType")
  if (seqType === SECURITY_TYPE.SWFX.id) {
    return `${Formatter.number(get(data, "Bid"), 2)} - ${Formatter.number(
      get(data, "Ask"),
      2
    )}`
  } else {
    return Formatter.number(get(data, "Price"), 2)
  }
}

//ブラウザ判定系
const userAgent = window.navigator.userAgent.toLowerCase()
export const checkIsBrowser = () => {
  if (includes(userAgent, "msie") || includes(userAgent, "trident")) {
    return "ie"
  } else if (includes(userAgent, "edge")) {
    return "edge"
  } else if (includes(userAgent, "chrome")) {
    return "chrome"
  } else if (includes(userAgent, "safari")) {
    return "safari"
  } else if (includes(userAgent, "fireFox")) {
    return "fireFox"
  } else if (includes(userAgent, "opera")) {
    return "opera"
  } else {
    return ""
  }
}

//sp判定
export const checkIsSp: () => boolean = () => {
  // androidは、タブレットの場合mobileが含まれない場合が多いので、androidかつmobileでマッチさせる。
  const isPhone: Array<string> | null = userAgent.match(
    /iphone|ipod|^(?=.*android)(?=.*mobile).*$/i
  ) //新しいiPadのSafariのUserAgencyにiPadが含まれない場合があるため以下の処理(今後使えなくなる可能性有)
  // const isNewIPad: boolean =
  //   includes(userAgent, "safari") &&
  //   !includes(userAgent, "chrome") &&
  //   typeof document.ontouchstart === "object"
  return !!isPhone
}

//iosのみ判定
export const checkIsIOS: () => boolean = () => {
  const isPhone: Array<string> | null = userAgent.match(/iphone|ipod|/i)
  return !!isPhone
}

// util関数
// 配列内に配列が含まれているか
type IncludeArrayType = <T>(arr1: Array<T>, arr2: Array<T>) => boolean
export const includeArray: IncludeArrayType = (arr1, arr2) => {
  let bool: boolean = true
  arr2.forEach(type => {
    if (!bool) return
    bool = includes(arr1, type)
  })
  return bool
}

//文言の改行を行う
export const makeSentenceBreakList = (
  list: APIResponse.Res,
  contentName: string
) =>
  chain(list)
    .get(contentName)
    .split("\r\n")
    .value()

// テーマ切替のFunction
export const changeThemeFunction = () => {
  const _colors = chartColors.initialize()
  UserStorage.ChartColor.set(_colors)
  return chartColorSetting(_colors)
}

// window_open後テーマをセットする。
export const setThemeFunction = () => {
  const themeColor = UserStorage.ThemeColor.get() || "bright"
  const htmlClass = document.querySelector("html").classList
  if (themeColor === "dark") {
    htmlClass.add("dark")
    htmlClass.remove("bright")
  } else {
    htmlClass.add("bright")
    htmlClass.remove("dark")
  }
}

const iconList = [
  { symbol: "JPY", exchange: 1, securityType: 13003, icon: "icon-jp" }, //日本
  { symbol: "USD", exchange: 100, securityType: 13005, icon: "icon-us" }, //アメリカ
  { exchange: 101, icon: "icon-us" },
  { exchange: 102, icon: "icon-us" },
  { symbol: "BRL", exchange: 110, securityType: 13021, icon: "icon-brazil" }, //ブラジル
  {
    symbol: "HKD",
    exchange: 2010,
    securityType: 13004,
    icon: "icon-hong-kong",
  }, //香港
  { exchange: 3010, icon: "icon-hong-kong" },
  { symbol: "CNY", exchange: 2020, securityType: 13002, icon: "icon-china" }, //中国
  { exchange: 3020, icon: "icon-china" },
  { symbol: "TWD", exchange: 2030, securityType: 13012, icon: "icon-taiwan" }, //台湾
  { symbol: "KRW", exchange: 2040, securityType: 13007, icon: "icon-korea" }, //韓国
  {
    symbol: "SGD",
    exchange: 2050,
    securityType: 13018,
    icon: "icon-singapore",
  }, //シンガポール
  { symbol: "THB", exchange: 2060, securityType: 13001, icon: "icon-thailand" }, //タイ
  { symbol: "MYR", exchange: 2070, securityType: 13014, icon: "icon-malaysia" }, //マレーシア
  {
    symbol: "IDR",
    exchange: 2080,
    securityType: 13011,
    icon: "icon-indonesia",
  }, //インドネシア
  {
    symbol: "PHP",
    exchange: 2090,
    securityType: 13010,
    icon: "icon-philippines",
  }, //フィリピン
  { symbol: "VND", exchange: 2100, securityType: 13008, icon: "icon-vietnam" }, //ベトナム
  { symbol: "ILS", exchange: 2110, icon: "icon-israel" }, //イスラエル
  { symbol: "INR", exchange: 2120, icon: "icon-india" }, //インド
  { symbol: "NZD", securityType: 13019, icon: "icon-new-zealand" }, //ニュージーランド
  { symbol: "AUD", securityType: 13020, icon: "icon-au" }, //オーストラリア
  { symbol: "GBP", securityType: 13013, icon: "icon-uk" }, //イギリス
  { symbol: "EUR", securityType: 13015, icon: "icon-eu" }, //ユーロ
  { symbol: "TRY", icon: "icon-turkey" }, //トルコ
  { symbol: "RUB", securityType: 13009, icon: "icon-russia" }, //ロシア
  { symbol: "CAD", icon: "icon-canada" }, //カナダ
  { symbol: "MXN", icon: "icon-mexico" }, //メキシコ
  { symbol: "ZAR", securityType: 13006, icon: "icon-south-africa" }, //南アフリカ
  { symbol: "DE", securityType: 13016, icon: "icon-germany" }, //ドイツ
  { symbol: "FR", securityType: 13017, icon: "icon-france" }, //フランス
  { symbol: "CH", icon: "icon-swiss" }, //スイス
  { symbol: "CLca", exchange: 14110, icon: "icon-us" }, //アメリカ
]

export const getCountryIcon = (data: APIResponse.Res) => {
  const securityTypeOfIndexList = [
    SECURITY_TYPE.Index.id,
    SECURITY_TYPE.CLc1.id,
  ]
  // const securityTypeOfCommodityList = [
  //   SECURITY_TYPE.XAU.id,
  //   SECURITY_TYPE.XAG.id,
  //   SECURITY_TYPE.GCc1.id,
  //   SECURITY_TYPE.SIc1.id,
  //   SECURITY_TYPE.PLc1.id,
  //   SECURITY_TYPE.PAc1.id,
  //   SECURITY_TYPE.CLc1.id,
  //   SECURITY_TYPE.XAUFIX.id,
  // ]
  const securityTypeOfGBList = [
    SECURITY_TYPE.THGBY10.id,
    SECURITY_TYPE.CNGBY10.id,
    SECURITY_TYPE.JPGBY10.id,
    SECURITY_TYPE.HKGBY10.id,
    SECURITY_TYPE.USGBY10.id,
    SECURITY_TYPE.ZAGBY10.id,
    SECURITY_TYPE.KRGBY10.id,
    SECURITY_TYPE.VNGBY10.id,
    SECURITY_TYPE.RUGBY10.id,
    SECURITY_TYPE.PHGBY10.id,
    SECURITY_TYPE.IDGBY10.id,
    SECURITY_TYPE.TWGBY10.id,
    SECURITY_TYPE.GBGBY10.id,
    SECURITY_TYPE.MYGBY10.id,
    SECURITY_TYPE.EUGBY10.id,
    SECURITY_TYPE.DEGBY10.id,
    SECURITY_TYPE.FRGBY10.id,
    SECURITY_TYPE.SGGBY10.id,
    SECURITY_TYPE.NZGBY10.id,
    SECURITY_TYPE.AUGBY10.id,
    SECURITY_TYPE.BRGBY10.id,
  ]

  const securityTypeOfFutureList = [
    SECURITY_TYPE.NK225_Future.id,
    SECURITY_TYPE.JPX400_Future.id,
    SECURITY_TYPE.JGB.id,
    SECURITY_TYPE.NK225Fc1.id,
    SECURITY_TYPE.NK225_Future_Mini.id,
    SECURITY_TYPE.TOPIX_Future_Mini.id,
    SECURITY_TYPE.CORE30_Future.id,
    SECURITY_TYPE.REIT.id,
    SECURITY_TYPE.TOPIX_Future.id,
  ]

  const securityTypeOfOptionList = [
    SECURITY_TYPE.NK225_Option.id,
    SECURITY_TYPE.TOPIX_Option.id,
  ]

  const exchangeTypeOfForeignSettlement = map(
    defaultTargetExchange.split(","),
    data => {
      return Number(data)
    }
  )

  const securityType = get(data, "SecurityType")
  const exchange = get(data, "Exchange")
  const countryCode = get(data, "CountryCode")
  // 日株
  if (securityType === 1) return "icon-jp"

  //為替
  if (securityType === SECURITY_TYPE.SWFX.id) {
    const symbols = get(data, "Symbol").split("/")
    if (symbols[1] === "JPY") {
      return get(
        find(iconList, row => {
          return row.symbol === symbols[0]
        }),
        "icon"
      )
    } else {
      const _symbol = find(symbols, data => data !== "USD")
      return get(
        find(iconList, row => {
          return row.symbol === _symbol
        }),
        "icon"
      )
    }
  }
  //政策金利
  else if (securityType === SECURITY_TYPE.PIR.id) {
    if (includes(["JPCALL", "JPDISCOUNT"], data.Symbol)) {
      return "icon-jp"
    }
    return get(
      find(iconList, row => {
        const _symbol = get(row, "symbol", "").slice(0, 2)
        return _symbol === data.Symbol
      }),
      "icon"
    )
  }

  //指数
  else if (includes(securityTypeOfIndexList, securityType)) {
    return get(
      find(iconList, row => {
        return row.exchange === data.Exchange
      }),
      "icon"
    )
  }

  //先物
  else if (includes(securityTypeOfFutureList, securityType)) {
    return "icon-jp"
  }

  // オプション
  else if (includes(securityTypeOfOptionList, securityType)) {
    return "icon-jp"
  }

  // //商品
  // else if (includes(securityTypeOfCommodityList, securityType)) {
  //   console.log("商品", data)
  // }

  //国債
  else if (includes(securityTypeOfGBList, securityType)) {
    return get(
      find(iconList, row => {
        return row.securityType === securityType
      }),
      "icon"
    )
  }
  //決算
  else if (includes(exchangeTypeOfForeignSettlement, exchange)) {
    return get(
      find(iconList, row => {
        return (
          String(row.exchange).substr(0, 3) === String(exchange).substr(0, 3)
        )
      }),
      "icon"
    )
  } else if (countryCode) {
    return get(
      find(iconList, row => {
        return get(row, "symbol", "").substr(0, 2) === countryCode
      }),
      "icon"
    )
  }
}

export const getCountryArea = (data: APIResponse.Res) => {
  const _exchange = get(data, "Exchange")
  let _countryArea = ""
  if (_exchange === EXCHANGE.TSE.id) {
    _countryArea = "japan"
  }
  if (_exchange === EXCHANGE.NYSE.id) {
    _countryArea = "usa"
  }
  if (includes(["20", "21", "30"], String(_exchange).substring(0, 2))) {
    _countryArea = "asia"
  }
  return _countryArea
}

type changedRatioType = {
  price: number | string
  lastClose: number | string
}

export const calcChangedRatio = (props: changedRatioType) => {
  const changedPrice = new BigNumber(props.price)
    .minus(props.lastClose)
    .toNumber()
  let changedRatio: number | string = new BigNumber(changedPrice)
    .div(props.lastClose)
    .times(100)
    .decimalPlaces(2, BigNumber.ROUND_FLOOR)
    .toFixed(2)
  changedRatio = parseFloat(changedRatio)
  return changedRatio
}

let isArray = Array.isArray
let keyList = Object.keys
let hasProp = Object.prototype.hasOwnProperty

export const deepEqual = (a: any, b: any) => {
  if (a === b) return true

  if (isFunction(a)) return true
  if (isFunction(b)) return true

  if (a && b && typeof a == "object" && typeof b == "object") {
    let arrA = isArray(a),
      arrB = isArray(b),
      i,
      length,
      key

    if (arrA && arrB) {
      length = a.length
      if (length != b.length) return false
      for (i = length; i-- !== 0; ) if (!deepEqual(a[i], b[i])) return false
      return true
    }

    if (arrA != arrB) return false

    let dateA = a instanceof Date,
      dateB = b instanceof Date
    if (dateA != dateB) return false
    if (dateA && dateB) return a.getTime() == b.getTime()

    let regexpA = a instanceof RegExp,
      regexpB = b instanceof RegExp
    if (regexpA != regexpB) return false
    if (regexpA && regexpB) return a.toString() == b.toString()

    let keys = keyList(a)
    length = keys.length

    if (length !== keyList(b).length) return false

    for (i = length; i-- !== 0; ) if (!hasProp.call(b, keys[i])) return false

    for (i = length; i-- !== 0; ) {
      key = keys[i]
      if (!deepEqual(a[key], b[key])) return false
    }

    return true
  }

  return a !== a && b !== b
}

type CheckHasSymbol = (
  arr: Array<APIResponse.Res>,
  symbol: APIResponse.Res
) => number
export const checkHasSymbol: CheckHasSymbol = (arr, symbol) => {
  let has: number = null
  arr.forEach((data, i) => {
    if (
      get(data, "Symbol") === get(symbol, "Symbol") &&
      get(data, "Exchange") === get(symbol, "Exchange") &&
      get(data, "SecurityType") === get(symbol, "SecurityType")
    ) {
      has = i
    }
  })
  return has
}

export const parseQueryString = (queryString: string, options = {}) => {
  const _options = {
    ignoreQueryPrefix: startsWith(queryString, "?"),
    ...options,
  }
  return qs.parse(queryString, _options)
}

export const getNumbersContiguousArray = (num: number) => {
  let arr = []
  for (let i = 1; i <= num; i++) {
    arr.push(i)
  }
  return arr
}

export const newsQueryString: object = (num: number) => {
  let obj: object = {}

  switch (num) {
    case ROUTE_LIST.TOP_SUMMARY:
      obj = {
        TopNCategory:
          "MDD_MARKET_REPORTS,MDD_ECONOMIC_CONDITIONS,MDD_FOREX_NEWS",
        TopNSource: "QK",
      }
      break
    case ROUTE_LIST.TOP_INDEX:
      obj = {
        _where:
          'Category = "MDD_MARKET_REPORTS" OR Category="MDD_ECONOMIC_CONDITIONS"',
      }
      break
    case ROUTE_LIST.TOP_EXCHANGE:
      obj = {
        _where: 'Category = "MDD_FOREX_NEWS"',
      }
      break
    case ROUTE_LIST.TOP_ECONOMICS:
      obj = {
        _where: 'Category = "MKW_IDX"',
      }
      break
    case ROUTE_LIST.TOP_BONDS:
      obj = {
        _where: 'Category = "MKW_FX"',
      }
      break
    case ROUTE_LIST.TOP_INSTRUMENT:
      obj = {
        _where: 'Category="MDD_FOREX_NEWS"',
      }
      break
    case ROUTE_LIST.DOMESTIC_SUMMARY:
      obj = {
        _where:
          'Category="MDD_MARKET_REPORTS" OR Category="MDD_IMPACT_NEWS" OR Category="MDD_REMARKABLE_NEWS" OR Category="MDD_FINANCIAL_RESULTS" OR Category="MDD_SPECIAL_EVENT" OR Source="QK"',
      }
      break
    case ROUTE_LIST.DOMESTIC_INDEX:
      obj = {
        _where: 'Category="MKW_NK" OR Category="MKW_JIX"',
      }
      break
    case ROUTE_LIST.DOMESTIC_AVERAGE:
      obj = {
        _where: 'Category="MKW_NK"',
      }
      break
    case ROUTE_LIST.DOMESTIC_INDUSTRY:
      obj = {
        _where: 'Category="MKW_NK" OR Category="MKW_IND"',
      }
      break
    case ROUTE_LIST.DOMESTIC_ETF:
      obj = {
        _where: 'Category="MKW_ETF"',
      }
      break
    case ROUTE_LIST.DOMESTIC_REIT:
      obj = {
        _where: 'Category="MKW_RIT"',
      }
      break
    case ROUTE_LIST.OVERSEAS_SUMMARY:
      obj = {
        _where: 'Category="MKW_IDX',
      }
      break
    case ROUTE_LIST.OVERSEAS_US:
      obj = {
        _where: 'Category="MKW_USA"',
      }
      break
    case ROUTE_LIST.OVERSEAS_CN:
      obj = {
        _where: 'Category="MKW_CHN" OR SubSystemID=2010',
      }
      break
    case ROUTE_LIST.OVERSEAS_HK:
      obj = {
        _where: 'Category="MKW_HKG" or SubSystemID=2020',
      }
      break
    case ROUTE_LIST.OVERSEAS_VN:
      obj = {
        _where: 'Category="MKW_VNM"',
      }
      break
    case ROUTE_LIST.OVERSEAS_KR:
      obj = {
        _where: 'Category="MKW_KOR"',
      }
      break
    case ROUTE_LIST.OVERSEAS_TW:
      obj = {
        _where: 'Category="MKW_TWN"',
      }
      break
    case ROUTE_LIST.OVERSEAS_SG:
      obj = {
        _where: 'Category="MKW_SGP"',
      }
      break
    case ROUTE_LIST.OVERSEAS_TH:
      obj = {
        _where: 'Category="MKW_THA"',
      }
      break
    case ROUTE_LIST.OVERSEAS_MY:
      obj = {
        _where: 'Category="MKW_MYS"',
      }
      break
    case ROUTE_LIST.OVERSEAS_ID:
      obj = {
        _where: 'Category="MKW_IDN"',
      }
      break
    case ROUTE_LIST.OVERSEAS_PH:
      obj = {
        _where: 'Category="MKW_PHL"',
      }
      break
    case ROUTE_LIST.OVERSEAS_IL:
      obj = {
        _where: 'Category="MKW_IDX"',
      }
      break
    default:
      // obj = {
      //   TopNCategory:
      //     "MDD_MARKET_REPORTS,MDD_ECONOMIC_CONDITIONS,MDD_FOREX_NEWS",
      //   TopNSource: "QK",
      // }
      break
  }
  return obj
}

export const getRoute = (code: string): number => {
  let path: number = -1
  if (isEmpty(code)) return path
  switch (code) {
    case countryList.usa:
      path = ROUTE_LIST.OVERSEAS_US
      break
    case countryList.hongkong:
      path = ROUTE_LIST.OVERSEAS_HK
      break
    case countryList.china:
      path = ROUTE_LIST.OVERSEAS_CN
      break
    case countryList.korea:
      path = ROUTE_LIST.OVERSEAS_KR
      break
    case countryList.taiwan:
      path = ROUTE_LIST.OVERSEAS_TW
      break
    case countryList.singapore:
      path = ROUTE_LIST.OVERSEAS_SG
      break
    case countryList.thai:
      path = ROUTE_LIST.OVERSEAS_TH
      break
    case countryList.malaysia:
      path = ROUTE_LIST.OVERSEAS_MY
      break
    case countryList.indonesia:
      path = ROUTE_LIST.OVERSEAS_ID
      break
    case countryList.philippine:
      path = ROUTE_LIST.OVERSEAS_PH
      break
    case countryList.vietnam:
      path = ROUTE_LIST.OVERSEAS_VN
      break
    case countryList.israel:
      path = ROUTE_LIST.OVERSEAS_IL
      break
    default:
      break
  }
  return path
}

// アイザワ証券PJでは表示はザラバ引けと終値引けのみ
export const getPriceCompareText = (
  PriceCompare: string,
  prevState: string,
  setState: Function
): string => {
  switch (PriceCompare) {
    case "0056":
      //変わらず
      return setState("　")
    case "0057":
      //↑
      return setState("arrow_upward")
    case "0058":
      //↓
      return setState("arrow_downward")
    case "0060":
      // ザラバ引け
      return setState("lens")
    case "0061":
      // 終値引け
      return setState("panorama_fish_eye")
    case "0068":
      return setState("停")
    case "0069":
      return setState("サ")
    default:
      return setState("　")
  }
}

type CapitalMovementsType = {
  movements: {
    type: number
    contents: string
  }
  finance: {
    type: number
    contents: string
  }
  paid: {
    type: number
    contents: string
  }
  free: {
    type: number
    contents: string
  }
}
const capitalMovementsType: CapitalMovementsType = {
  movements: { type: 11, contents: "ChangedContents" },
  finance: { type: 12, contents: "FinanceType" },
  paid: { type: 14, contents: "有償割当" },
  free: { type: 15, contents: "無償割当" },
}

export const getCapitalMovementsType = (row: object, type: number) => {
  switch (type) {
    case capitalMovementsType.free.type:
      //無償割当
      return capitalMovementsType.free.contents
    case capitalMovementsType.paid.type:
      //有償割当
      return capitalMovementsType.paid.contents
    case capitalMovementsType.movements.type:
      //資本移動
      return get(row, capitalMovementsType.movements.contents, "-")
    case capitalMovementsType.finance.type:
      //ファイナンス銘柄
      return get(row, capitalMovementsType.finance.contents, "-")
    default:
      return ""
  }
}

export const judgingDomesticEquity = (data: APIResponse.Res) => {
  return get(data, "SecurityType") === SECURITY_TYPE.Equity.id
}

export const judgingKakuhoFlag = (flag: number) => {
  switch (flag) {
    case 0:
      return "速報"
    case 1:
      return "確報"
    default:
      return ""
  }
}

export const priceCompareIcon = (priceCompare: string) => {
  return priceCompare === "0057"
    ? "up"
    : priceCompare === "0058"
    ? "down"
    : priceCompare === "0060"
    ? "dotted"
    : priceCompare === "0061"
    ? "circle"
    : "compare-default"
}

export const getRate = (data: Array<object>, exchange?: number) => {
  if (!data || !data.length || !exchange) return 0
  let rate = 1
  let symbol = ""
  if (exchange !== 1 && exchange !== 3 && exchange !== 5 && exchange !== 6) {
    //国内株以外ならレートを取得
    RateList.map((row, id) => {
      if (get(row, "exchange") === exchange) {
        symbol = get(row, "symbol")
      }
    })
    data.map((listRow, num) => {
      if (get(listRow, "Symbol") === symbol) {
        rate = get(listRow, "Price")
      }
    })
  }
  return rate
}

export const checkNoneData = (data: number | string) => {
  return !!data || data === 0 ? true : false
}

export const CheckHasProperties = (data: object, properties: Array<string>) => {
  const res = map(properties, property => {
    if (!has(data, property)) return false
    return true
  })
  return !includes(res, false)
}

//Priceがnullかundefinedの場合LastCloseとLastCloseTimeを表示したい場合に使用する
export const getPriceOrLastClose = (data: APIResponse.Res) => {
  if (isNil(get(data, "Price"))) {
    return [get(data, "LastClose", null), get(data, "LastCloseTime", "")]
  } else {
    return [get(data, "Price", null), get(data, "PriceTime", "")]
  }
}

//ベンダー事情で値が取得でいない場合任意の値を表示する(return: boolean)
export const isHideParam = (data: APIResponse.Res) => {
  //SecurityType:0であればExchangeで判断。ではなければSecurityTypeで判断
  if (get(data, "SecurityType") === SECURITY_TYPE.Index.id) {
    return includes([EXCHANGE.NYSE.id, EXCHANGE.ILSE.id], get(data, "Exchange"))
  } else {
    return includes([SECURITY_TYPE.US_Equity.id], get(data, "SecurityType"))
  }
}

//小数点桁数取得
export const getDecimalPointLength = (num: number) => {
  const numbers = String(num).split(".")
  return numbers[1] ? numbers[1].length : 0
}

//親windowが閉じていないか監視　閉じていたら自身も閉じる
export const checkParentWindow = () => {
  let parentWindow
  setInterval(() => {
    parentWindow = window.opener
    if (isNull(parentWindow)) {
      window.close()
    }
  }, 500)
}
